// src/components/Header.js
// import { useEffect } from "react";
import { NavLink } from "react-router-dom";
// import { useProfile } from "../context/ProfileContext";
import { useSelector } from "react-redux";
// import { setAuthToken } from "../api/tokenService";

function Header() {

  const profile = useSelector((state) => {
    return state.profile;
  });

  const routeTree = useSelector((state) => {
    return state.route;
  });

  return (
    <header>
      <h1>{ routeTree.header? routeTree.header : 'Oct 18 System'}</h1>
      { routeTree.route?
      <nav className="top-nav">
        { routeTree.route.category.map ((cat) => (
          <NavLink
          key={cat.rootPath}
          to={cat.rootPath}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          {cat.title}
        </NavLink>
        ))
      }
        <NavLink
          to="/reports"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Tools
        </NavLink>
      </nav> : <></> }
      <div className="auth-section">
        {profile.picture ? (
          <div className="user-info">
            <img src={profile.picture} alt="Profile" className="profile-pic" />
            <span>{profile.given_name} </span>
          </div>
        ) : (
          <div />
        )}
      </div>
    </header>
  );
}

export default Header;
